import { Flex, Text } from '@components';
import { LaptopAndUp, TabletAndDown } from 'src/components/stylingUtils';
import styled from 'styled-components';

const ImageContainer = styled.div<{ src?: string | null }>`
  ${({ src }) =>
    src
      ? `
    background-image: url('${src}');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;`
      : ''}
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 0;
  transition: transform 0.45s cubic-bezier(0.33, 0.7, 0.32, 1) 0ms;
`;

export default {
  Container: styled(Flex)`
    @media (max-width: 1150px) {
      padding-left: 120px;
    }

    ${props => TabletAndDown(props)} {
      display: none;
    }
  `,
  CloseButton: styled.div`
    cursor: pointer;

    ${props => LaptopAndUp(props)} {
      transition: transform 100ms ease-in-out;

      &:hover {
        transform: scale(1.3);
      }
    }
  `,
  Delimiter: styled(Flex)`
    width: 2px;
    background-color: ${props => props.theme.colors.background};
    margin: 0 64px;
  `,
  MenuColumn: styled(Flex).attrs({ vertical: true })`
    width: 280px;
    min-width: 280px;
  `,
  ContentColumn: styled(Flex).attrs({ vertical: true })`
    width: 572px;
  `,
  MenuLink: styled(Text.Span18_22)`
    cursor: pointer;
    &:hover {
      color: ${props => props.theme.colors.text.onWhitePrimary};
    }
  `,
  CloseButtonContainer: styled.div`
    position: absolute;
    right: 0;
    top: 0;
    padding: inherit;
  `,
  Click: styled.a`
    text-decoration: none;
    ${props => (props.onClick ? 'cursor:pointer;' : '')}
  `,
  PreviewImage: styled(ImageContainer)`
    min-width: 130px;
    width: 130px;
    height: 100px;
    position: static;
    z-index: 0;
  `,
  MenuIndicator: styled.div`
    position: absolute;
    height: 3px;
    background-color: ${props => props.theme.colors.error};
    width: 0;
    bottom: 0;
    pointer-events: none;
    transition: transform 0.5s cubic-bezier(0.25, 1.5, 0.5, 1), width 0.3s ease, height 0.3 ease;
  `
};
